import { get, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { realTimeDB } from "../firebase";
import { HbrLiveCam, HbrPlayButtonRound } from "./Mycustomsvgicons";
import ReactPlayer from "react-player";

const CustomLiveWebview = () => {
    const [liveStarted,setLiveStarted]=useState(true);
    const [hlsUrl,setHlsUrl]=useState("");
    const [playing,setIsPlaying]=useState(false);
    const [buffering,setBuffering]=useState(false);
    const [ispaused,setIspaused]=useState(false);

    const handleIspaused=()=>{
        setIspaused(true);
    };
    const handleIsplaying=()=>{
        setIspaused(false);
    };

    const handleBuffering=()=>{
        setBuffering(true);
    };

    const handleBufferEnd=()=>{
        setBuffering(false);
    };

    useEffect(()=>{
        async function fetchUrl() {
               const hlsUrlSnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/hlsUrl"));
               setHlsUrl(hlsUrlSnapshot.val());
               const livebooleanvalue = await get(ref(realTimeDB,"Banner/hbrLiveSettings/live"));
               setLiveStarted(livebooleanvalue.val());
        };
        fetchUrl();
    },[]);
    

    return ( 
        <div className="flex-column2" style={{width:"100%",height:"100vh",backgroundColor:"black",position:"relative"}} onContextMenu={(e)=>e.preventDefault()}>
              {liveStarted && 
                    <div className="flex-row1" style={{width:"100%",height:"auto"}}>
                        <div className='flex-row2'
                         style={{
                             padding:"3px",
                             gap:"3px",
                             width:"fit-content",
                             border:"none",
                             backgroundColor:"red",
                             color:"white",
                             fontWeight:"bold",
                             fontSize:"0.8em",
                             borderRadius:"10px",
                             animation:"fade180 2s linear infinite"}}>
                             <h4 style={{color:"white"}}>Live </h4>
                             <HbrLiveCam width="1em" height="1em" fillColour="#FFFFFF"/>
                         </div>

                    </div>
                
                }

             {liveStarted && 
                <div style={{width:"100%",height:"100%"}}
                    onClick={()=>setIsPlaying(prev => !prev)} onContextMenu={e => e.preventDefault()}>
               
                    <ReactPlayer 
                        url={hlsUrl}
                        playing={playing}
                        onReady={handleIspaused}
                        onPause={handleIspaused}
                        onPlay={handleIsplaying}
                        onBuffer={handleBuffering}
                        onBufferEnd={handleBufferEnd}
                        width={"100%"}
                        height={"100%"}
                        controls
                    />
                </div>
             } 

            {ispaused &&
            <div onClick={()=>setIsPlaying(prev => !prev)} className="videoplaypausebtn" >
                <HbrPlayButtonRound width="3em" height="3em" fillColour="white" />
            </div>                                      
            }                             

            {buffering && 
                <div style={{
                position:"absolute",
                top:"45%",
                left:"45%",
                width:"50px",
                height:"50px",
                borderRadius:"50px",
                border:"5px solid white",
                borderTop: "5px solid #eb268f",
                animation: "spin 2s linear infinite"
                }}>
                    
                </div>
            }
            
           
        </div>
     );
}
export default CustomLiveWebview;